import React from "react";

import { Box, Stack, Group, Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconDownload } from "@tabler/icons-react";
import { useRouter } from "next/router";

import { useTrackerUser } from "components/AuthProvider";
import { useSearchRouteInfo } from "hooks/routing";

import { ExportModal, UpgradeModal } from "./ExportModal";
import { FilterSidebar } from "./FilterSidebar";

export function SearchSidebar(): JSX.Element {
  const { query, queryString } = useSearchRouteInfo();
  const router = useRouter();
  const user = useTrackerUser();
  const [exportModalOpened, { open: openExportModal, close: closeExportModal }] =
    useDisclosure(false);
  const [upgradeModalOpened, { open: openUpgradeModal, close: closeUpgradeModal }] =
    useDisclosure(false);
  const sidebarKey = query.title[0] + query.jobFamily[0] + query.level[0];

  // Check if user is a paid user (has a company ID)
  const isPaidUser = !!user?.companyId;

  // Handle export button click
  const handleExportClick = () => {
    if (isPaidUser) {
      openExportModal();
    } else {
      openUpgradeModal();
    }
  };

  return (
    <Box w={"100%"}>
      <Stack gap={0}>
        <Group
          h={62}
          align="center"
          justify="center"
          mb={16}
          sx={{
            backgroundColor: "var(--mantine-color-white)",
            borderBottom: "1px solid var(--mantine-color-gray-3)",
            width: "300px",
            // padding: "0 8px",
            marginLeft: "-6px",
            // marginRight: "-16px",
          }}
        >
          <Group ml="md" mr="lg" w="100%">
            <Button
              variant="secondary"
              size="sm"
              leftSection={<IconDownload size={20} />}
              onClick={handleExportClick}
              fullWidth
            >
              Export Data
            </Button>
            {/* <UpSellButton
            variant="tertiary"
            size="sm"
            leftSection={<IconShare3 size={20} />}
            withSparkle={false}
            w={120}
          >
            Share
          </UpSellButton> */}
          </Group>
        </Group>
        <FilterSidebar key={sidebarKey} />
      </Stack>

      <ExportModal
        opened={exportModalOpened}
        onClose={closeExportModal}
        currentQueryString={queryString}
      />
      <UpgradeModal opened={upgradeModalOpened} onClose={closeUpgradeModal} />
    </Box>
  );
}
